module.exports = __webpack_public_path__ + "img/feedback10-3.c7af549b.jpg";